<template>
<uiv-modal v-model="error"
       :dismiss-btn="false"
       :ok-text="'Got it!'"
       v-on:hide="propagateHideEvent">
    <div class="error-header">
        <div class="error-header-text" style="border">
            <h4><b>Error when signing up</b></h4>
        </div>
    </div>
    <div class="body-text">
        <div class="body-text-top">
            Have you signed up previously? Then log in by opening DataMapper on your
            computer (see description below). If you have not
            already signed up, please contact support
        </div>
        <div class="modal-advice-box">
            <p>
                <i class="icon-windows"></i>
                <b>
                    Windows
                </b>
            </p>
            Either go to your start menu and find DataMapper
            under A or click on the windows key on your keyboard
            and type 'DataMapper'
        </div>
        <div class="modal-advice-box">
            <p>
                <i class="icon-apple"></i>
                <b>
                    Mac
                </b>
            </p>
            Either go to your start menu and find DataMapper under A
            or click on the windows key on your keyboard and type 'DataMapper'
        </div>
        <div class="body-text-bottom">
            If DataMapper GDPR is not yet installed on your computer download it
            <router-link to="/download-direct">here</router-link>
        </div>
</div>
</uiv-modal>
</template>

    <script>
    export default {
        name: 'SignupError',
        data () {
            return {
                error: true
            }
        },
        methods: {
            propagateHideEvent() { this.$emit('hide') }
        }
    }
</script>

<style scoped lang="scss">
@import "~@/assets/scss/index.scss";


.test {
    border: 1px solid red;
}
.modal-dialog {
    /*border: 1px solid black;*/
    background-color: white;

    button.btn-primary {
        @extend %base-button;
    }

    .modal-content {
        border-radius: 15px;
    }

    .modal-body {
    background-color: white;
    color: black;
    /*border: 1px solid red;*/
    width: 100%;
    padding: 0 12% 2% 12%;
    }

    border-radius: 15px;
}

div div div.error-header-text {
    text-align: left;
}



.error-header {
    color: red;
    margin-bottom: 4px;
    border-bottom: 2px solid #00c0ed;
}

.modal-header {
    border: 0px;
}

.modal-footer {
    border: 0px;
    padding-right: 10%;
    padding-bottom: 5%;
}

.modal-advice-box {
    margin: 0 0 8px 0%;
    padding: 8px 3px 3px 8px;
    /*border: 1px solid black;*/
    background-color: #efefef;
}

.modal-footer .btn-default {
    display: none;
}

.body-text-top {
    margin-top: 10px;
    margin-bottom: 15px;
}

.body-text-bottom {
    margin-top: 25px;
    margin-bottom: 40px;
}

</style>


// WEBPACK FOOTER //
// apps/account/SignupError.vue